import { getListingLabel } from "@/utils";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";

const AppBadge = ({ propertyListingType, classes }) => {
  const { t } = useTranslation();

  return (
    <Tag
      className={`${
        propertyListingType === "SELL"
          ? "bg-[#E4FAE6] text-[#31493C] border border-[#C5E9C9]"
          : "bg-[#FFF2E9] text-[#F76100] border border-[#FFDAC2]"
      } inline-block font-manropeBold font-bold uppercase text-[10px] px-2.5 py-[2.8px] rounded mb-2 ${classes}`}>
      {getListingLabel(propertyListingType, t)}
    </Tag>
  );
};

export default AppBadge;
